<template>
    <app-layout title="Nafacturatie">
        <template #header>
            <page-title :title="'Nafacturatie ' + postInvoice.request.reference" />
        </template>

        <template #pageContent>
            <Button
                htmlType="a"
                buttonClass="edit"
                text="Bewerken"
                :href="route('accountancy.post-invoices.edit-post-invoice', { 'postInvoice': postInvoice.id })"
            />
            <ModalAttachments :request="postInvoice.request" :attachments="attachments" :attachmentTypes="attachmentTypes" :attachmentsPath="attachmentsPath" />
            <Table class="border-0 mt-4 w-auto max-w-[500px]">
                <tr>
                    <Td class="border-0 pl-0">Aanvraag:</Td>
                    <Td class="border-0">
                        <a :href="route('requests.detail',  {'id': postInvoice.request.id})" >
                            {{ postInvoice.request.reference }}
                        </a>
                    </Td>
                </tr>
                <tr>
                    <Td class="border-0 pl-0">Status:</Td>
                    <Td class="border-0">{{ statusses[postInvoice.request.status] }}</Td>
                </tr>
                <tr>
                    <Td class="border-0 pl-0">Nummer nafacturatie:</Td>
                    <Td class="border-0">{{ postInvoice.reference }}</Td>
                </tr>
                <tr>
                    <Td class="border-0 pl-0">Status nafacturatie:</Td>
                    <Td class="border-0">{{ statusses[postInvoice.status] }}</Td>
                </tr>
                <tr>
                    <Td class="border-0 pl-0">Extra info asbest:</Td>
                    <Td class="border-0">{{ postInvoice.info_asbestos }}</Td>
                </tr>
                <tr>
                    <Td class="border-0 pl-0">Extra info boekhouding:</Td>
                    <Td class="border-0">{{ postInvoice.info_accounting }}</Td>
                </tr>
                <tr>
                    <Td class="border-0 pl-0">Bijlage:</Td>
                    <Td class="border-0">
                        <a
                            :href="'/accountancy/post-invoices/' + postInvoice.id + '/post-invoice/download-attachment'"
                            v-if="postInvoiceAttachment"
                        >
                            {{ postInvoiceAttachment.file }}
                        </a>
                    </Td>
                </tr>
            </Table>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'

import ModalAttachments from "@/Components/Requests/ModalAttachments.vue";

import store from '@/store'

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        ModalAttachments,
    },
    props: [
        'postInvoice',
        'statusses',
        'postInvoiceAttachment',
        'attachmentTypes',
        'attachmentsPath',
        'attachments',
    ],
    setup (props)
    {
        return {
            state: store.state,
            ...store,
        }
    },
}

</script>

<style scoped>
tr.nohover:hover td  {
    background: none;
}
</style>
